/**
 * This file is responsible for handling the service calls for the account
 */
import store from "../store";
import {
	callAPI,
	chameau,
	DEFAULT_LIST_PARAMS,
	GATEWAY_PROXY,
	METHODS,
} from "utils/apiUtils";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";

export function createContactExportService(
	options = { id: "", description: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	const { id, ...rest } = options;

	callAPI(
		{
			url: GATEWAY_PROXY + `/lists/${id}/exports`,
			query: { ...rest, account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.CONTACT_EXPORT, { options });
			successCallback(data);
		},
		failureCallback
	);
}

export function listTasksService(
	options = DEFAULT_LIST_PARAMS,
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/tasks",
			method: METHODS.get,
			query: {
				...chameau(options),
				account_id: store.getState().global.account.id,
			},
		},
		successCallback,
		failureCallback
	);
}

export function getContactExportService(
	options = { exportId: "", listId: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url:
				GATEWAY_PROXY + `/lists/${options.listId}/exports/${options.exportId}`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
}

export function getTaskService(
	options = { exportId: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + `/tasks/${options.exportId}`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		successCallback,
		failureCallback
	);
}

export function downloadContactExportService(
	options = { listId: "", exportId: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url:
				GATEWAY_PROXY +
				`/lists/${options.listId}/exports/${options.exportId}/download`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.CONTACT_EXPORT_DOWNLOAD, {
				exportId: options.exportId,
				listId: options.listId,
			});
			successCallback(data);
		},
		failureCallback
	);
}

export function createCampaignLogExportService(
	options = { campaignId: "", description : "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	const { campaignId, ...rest } = options;
	callAPI(
		{
			url: GATEWAY_PROXY + `/logs/campaigns/${campaignId}/exports`,
			method: METHODS.post,
			query: { ...rest, account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.CAMPAIGN_LOG_EXPORT, {
				campaign_id: options.campaignId,
			});
			successCallback(data);
		},
		failureCallback
	);
}

export function downloadCampaignLogExportService(
	options = { campaignId: "", exportId: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url:
				GATEWAY_PROXY +
				`/logs/campaigns/${options.campaignId}/exports/${options.exportId}/download`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.CAMPAIGN_LOG_DOWNLOAD, {
				export_id: options.exportId,
				campaign_id: options.campaignId,
			});
			successCallback(data);
		},
		failureCallback
	);
}

export function createCampaignsReportsExport(
	options = {},
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/reports/campaigns-exports",
			method: METHODS.post,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.CAMPAIGNS_REPORTS_EXPORT);
			successCallback(data);
		},
		failureCallback
	);
}

export function downloadCampaignReportsExportService(
	options = { exportId: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url:
				GATEWAY_PROXY +
				`/reports/campaigns-exports/${options.exportId}/download`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.CAMPAIGNS_REPORTS_EXPORT_DOWNLOAD);
			successCallback(data);
		},
		failureCallback
	);
}

export function createSuppressedEmailsExport(
	options = {},
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + "/reports/suppressed-emails-exports",
			method: METHODS.post,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.SUPPRESSED_EMAIL_EXPORT);
			successCallback(data);
		},
		failureCallback
	);
}

export function downloadSuppressedEmailsExportService(
	options = { exportId: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url:
				GATEWAY_PROXY +
				`/reports/suppressed-emails-exports/${options.exportId}/download`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.SUPPRESSED_EMAIL_EXPORT_DOWNLOAD);
			successCallback(data);
		},
		failureCallback
	);
}

export function downloadListLogsExportService(
	options = {
		exportId: "",
		listId: 0,
	},
	successCallback = () => { },
	failureCallback = () => { }
) {
	callAPI(
		{
			url: `${GATEWAY_PROXY}/logs/lists/${options.listId}/exports/${options.exportId}/download`,
			method: METHODS.get,
			query: { account_id: store.getState().global.account.id },
		},
		(data) => {
			trackSegmentEvent(SEGMENT_EVENTS.LIST_LOGS_EXPORT_CREATED);
			successCallback(data);
		},
		failureCallback
	);
}
